import { BaseTable, Card, FooterMenu, HeaderMenu, Label, Loading, Select, TableHeader } from "components";
import { appDropdown } from "pages/Purchase/Transaction/ApproveReceivedRejected/utils";
import { useState } from "react";
import { useListDropdownSchedule } from "./hooks";
import moment from "moment";
import { CreateApproval } from "./components/Approval";

export default function ApprovalShiftSchedule() {

    const [approval, setApproval] = useState<string>("1")
    const {data, isLoading, refetch} = useListDropdownSchedule({approve_status: approval})


    return (
       <section className="container my-2">
             <section>
               <div className="sticky top-[39px] z-[2]">
                 <HeaderMenu title="SCHEDULE SHIFT APPROVAL" />
               </div>
       
               <div className="sticky top-[86px] z-[2]">
                 <Card>
                   <Card.Body>
                     <div className="justify-end lg:flex items-center">
                       <Label className="mr-2">APPROVAL</Label>
                       <Select
                         className="lg:w-[200px]"
                         placeholder="Select Approval"
                         options={appDropdown}
                         value={appDropdown.find(
                           (item) => item.value === approval
                         )}
                         onChange={(e) =>
                           setApproval(e?.value as string)
                         }
                       />
                     </div>
                   </Card.Body>
                 </Card>
               </div>
       
               <section className="mt-2">
                 <Card>
                   <Card.Body>
                     <div className="overflow-auto max-h-[calc(100svh-500px)]">
                       <BaseTable>
                         <TableHeader className="sticky top-0 z-[0]">
                           <tr>
                             <th>No</th>
                             <th colSpan={2}>SCHEDULE  ID#</th>
                             <th>PERIODE START</th>
                             <th>PERIODE END</th>
                           </tr>
                         </TableHeader>
                         <tbody>
                            {isLoading || !data.length ? (
                              <tr>
                                <td colSpan={5}>
                                  <Loading
                                    loading={isLoading}
                                    errorText="No data available"
                                  />
                                </td>
                              </tr>
                            ): data.map((item, key) => (
                              <tr key={key}>
                                <td>{key + 1}</td>
                                <td>
                                    <CreateApproval 
                                        data={item} 
                                        refetch={refetch}
                                    />
                                </td>
                                <td >{item.trx_code}</td>
                                <td>{moment(item.periode_start).format("DD/MM/YYYY")}</td>
                                <td>{moment(item.periode_end).format("DD/MM/YYYY")}</td>
                              </tr>
                            ))}
                         </tbody>
                       </BaseTable>
                     </div>
                   </Card.Body>
                 </Card>
               </section>
       
               <section className="mt-2">
                 <FooterMenu />
               </section>
             </section>
           </section>
    )
}